/**
 * UTM + QR-source parameter helpers.
 * Centralized for cookie-consent / GDPR readiness later.
 */
export function getUrlParam(key) {
  if (typeof window === "undefined") return null;
  const sp = new URLSearchParams(window.location.search);
  return sp.get(key);
}

export function getUTM() {
  return {
    utm_source: getUrlParam("utm_source"),
    utm_medium: getUrlParam("utm_medium"),
    utm_campaign: getUrlParam("utm_campaign"),
  };
}

export function getQRSource() {
  return {
    restaurant_id: getUrlParam("restaurant_id"),
    shop_id: getUrlParam("shop_id"),
    qr_source: getUrlParam("qr_source"),
    source: getUrlParam("source"),
  };
}
